module.exports = __webpack_public_path__ + "static/0329-a08fe54b98261620ff04d8b9980f1499.jpg";